export enum FulfilmentTypeEnum {
	Collection = 10,
	Delivery = 20,
}